// Ícone do Pomodoro na janela principal (P0.5): um tomate — parado e apagado com o
// Pomodoro desligado, saltitando com ele ligado. Ligar abre o pop-up (AC-068); desligar é um clique.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppState } from '../state/AppStore';
import { usePomodoro } from '../state/usePomodoro';
import { cls } from './NewTaskForm';
import { PomodoroSetupDialog } from './PomodoroSetupDialog';
import { Tomato } from './Tomato';

export function PomodoroToggle({ disabled }: { disabled?: boolean }) {
  const { t } = useTranslation();
  const enabled = useAppState((s) => !!s.profile?.pomodoro_enabled);
  const { controller } = usePomodoro();
  const [setup, setSetup] = useState(false);
  return (
    <>
      <button
        type="button"
        className={cls('icon-btn', enabled && 'icon-btn--on')}
        aria-pressed={enabled}
        aria-label={enabled ? t('pomodoro.turnOff') : t('pomodoro.turnOn')}
        title={enabled ? t('pomodoro.turnOff') : t('pomodoro.turnOn')}
        disabled={disabled}
        onClick={() => (enabled ? void controller.setEnabled(false) : setSetup(true))}
      >
        <Tomato size={25} still={!enabled} />
      </button>
      {setup && <PomodoroSetupDialog onClose={() => setSetup(false)} />}
    </>
  );
}
